const agentSystemNoticeStyles = {
  routine: "border-[var(--line-2)] bg-[var(--transparency-block)]",
  contextHandoff: "border-[var(--on-danger-hover)] bg-[var(--on-danger)]"
} as const;

export default agentSystemNoticeStyles;
